import { render, staticRenderFns } from "./ClientServices.vue?vue&type=template&id=2600512b&scoped=true"
import script from "./ClientServices.vue?vue&type=script&lang=ts"
export * from "./ClientServices.vue?vue&type=script&lang=ts"
import style0 from "./ClientServices.vue?vue&type=style&index=0&id=2600512b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600512b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2600512b')) {
      api.createRecord('2600512b', component.options)
    } else {
      api.reload('2600512b', component.options)
    }
    module.hot.accept("./ClientServices.vue?vue&type=template&id=2600512b&scoped=true", function () {
      api.rerender('2600512b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/ClientServices.vue"
export default component.exports